export const TAB_QUERY_KEY = 'tab';

// Kept here (leaf module) rather than in utils.tsx: the route registry
// (pages/corporate/routes/feedback.ts) imports FeedbackTabs, and utils.tsx pulls
// icons/components plus the registry itself back (an import cycle).
export enum FeedbackTabs {
  MyFeedback = 'my_feedback',
  GivenByMe = 'given_by_me',
  MyTeam = 'my_team',
  Requests = 'requests',
}

export const DEFAULT_FEEDBACK_TAB = FeedbackTabs.MyFeedback;
